// extracted by mini-css-extract-plugin
export default {"wrapper":"r1-z","play":"s1-z"};